// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-call-card {
  background: #FFFFFF 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 0px 12px #0000000A !important;
  border-radius: 8px !important;
  opacity: 1;
  width: 100%;
  max-width: 964px;
}

.main-call-card .ant-card-body {
  padding-top: 35px !important;
  padding-bottom: 32px !important;
  padding-left: 32px !important;
  padding-right: 32px !important;
}

.job-call-card-heading {
  text-align: left;

  font-size: 14px;
  line-height: 19x;
  letter-spacing: 0px;
  color: #AAAAAA !important;
  opacity: 1;
}

.job-call-card-heading-bold {
  font-weight: 500;
  color: #212121 !important
}

.job-main-call-detail-wrapper {
  margin-top: 18px;
}

.job-call-card-details {
  text-align: left;
  font-weight: 500;
  font-size: 20px;
  line-height: 26px;
  color:  #212121 !important;
  opacity: 1
}

.job-call-card-detail-light {
  margin-top: 12px;
  text-align: left;

  font-size: 14px;
  line-height: 26px;
  letter-spacing: 0;
  color: #888888 !important;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/JobMainCallAction/index.css"],"names":[],"mappings":"AAAA;EACE,0DAA0D;EAC1D,6CAA6C;EAC7C,6BAA6B;EAC7B,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;;EAEhB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;;EAEhB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ","sourcesContent":[".main-call-card {\n  background: #FFFFFF 0% 0% no-repeat padding-box !important;\n  box-shadow: 0px 0px 12px #0000000A !important;\n  border-radius: 8px !important;\n  opacity: 1;\n  width: 100%;\n  max-width: 964px;\n}\n\n.main-call-card .ant-card-body {\n  padding-top: 35px !important;\n  padding-bottom: 32px !important;\n  padding-left: 32px !important;\n  padding-right: 32px !important;\n}\n\n.job-call-card-heading {\n  text-align: left;\n\n  font-size: 14px;\n  line-height: 19x;\n  letter-spacing: 0px;\n  color: #AAAAAA !important;\n  opacity: 1;\n}\n\n.job-call-card-heading-bold {\n  font-weight: 500;\n  color: #212121 !important\n}\n\n.job-main-call-detail-wrapper {\n  margin-top: 18px;\n}\n\n.job-call-card-details {\n  text-align: left;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 26px;\n  color:  #212121 !important;\n  opacity: 1\n}\n\n.job-call-card-detail-light {\n  margin-top: 12px;\n  text-align: left;\n\n  font-size: 14px;\n  line-height: 26px;\n  letter-spacing: 0;\n  color: #888888 !important;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
